export const NAME = 'uwbDemo';
